import { UPDATE_ENTITIES } from '../../state/redux/features/normalized/types';

export default function set(key, params) {
  switch (key) {
    case 'cartItems': {
      return this.internalStore.dispatch({
        type: UPDATE_ENTITIES,
        payload: { cart: params },
      });
    }
    case 'listItems': {
      return this.internalStore.dispatch({
        type: UPDATE_ENTITIES,
        payload: { listItems: params },
      });
    }
    default:
      return null;
  }
}
